import { basuraConfig } from './basura';
import { bachesConfig } from './baches';
import { arbolConfig } from './arbol';
import { senHorizConfig } from './sen_horiz';
import { alumbradoConfig } from './alumbrado';
import { semaforoConfig } from './semaforo';

export const categories = [
  basuraConfig,
  bachesConfig,
  arbolConfig,
  senHorizConfig,
  alumbradoConfig,
  semaforoConfig,
];

export const getCategoryConfig = (id) => {
  return categories.find(c => c.id === id) || {
    id: id,
    label: id.charAt(0).toUpperCase() + id.slice(1),
    regex: new RegExp(id),
    subFilters: [],
    calculatePriority: () => 'Baja',
    calculateCompany: () => 'N/A',
    summaryConfig: { mainChart: 'locality' },
    hasPriority: false,
    hasCompany: false,
    renderExtraInfo: () => null,
    jsonFields: []
  };
};

export const getCategoryByItem = (item) => {
  if (!item) return null;
  const tipo = (item.tipo || '').toLowerCase();
  const tipoEsp = (item.tipo_especifico || '').toLowerCase();
  const text = tipo + tipoEsp;

  return categories.find(c => c.regex.test(text)) || null;
};
